/**
 * @module Components.StripeForm
 *
 * Renders a coach's existing payment method (masked card + expiry). Shared by the
 * checkout/upgrade flows so the saved-card display isn't duplicated per screen.
 */
import React from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { cls } from "app/utils";
import { PaymentInfoModel } from "app/models";
import styles from "./styles.module.scss";

type PropsDef = {
  paymentInfo: PaymentInfoModel;
  className?: string;
};

const SavedPaymentMethod = ({ paymentInfo, className }: PropsDef) => {
  const { t } = useTranslation();

  return (
    <div className={cls(styles.saved_card, className)}>
      <span>{`•••• •••• •••• ${paymentInfo.cardLast4}`}</span>
      {paymentInfo.cardExpiry && (
        <span className={styles.expiry}>
          {t("Expires {{expires}}", {
            expires: moment(paymentInfo.cardExpiry).format("MM/YY"),
          })}
        </span>
      )}
    </div>
  );
};

export default SavedPaymentMethod;
